@switch (type?.toLowerCase()) {
  @case("search") {
    <mat-form-field class="width100procent rahmen">
      <mat-label>{{title$ | async}}</mat-label>
      <input  matInput
        type="search"
        #inputElement
        [ngModel]="value$ | async"
        (ngModelChange)="onModelChange($event)"
        />
      <button matSuffix mat-icon-button aria-label="Search" (click)="clearValue()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
  }
  @case("date") {
    <mat-form-field class="width100procent rahmen">
      <mat-label>{{title$ | async}}</mat-label>
      <input
        matInput
        [disabled]="readonly"
        [required]="isRequired"
        [matDatepicker]="picker"
        [placeholder]="dateFormat"
        #inputElement
        [ngModel]="value$ | async"
        (dateChange)="onModelChangeDate($event)"
        />
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker [disabled]="readonly" ></mat-datepicker>
      <mat-error>
        Wert mit Format {{dateFormat}} eingegeben!
      </mat-error>
    </mat-form-field>
  }
  @case("password") {
    <mat-form-field class="width100procent rahmen">
      <mat-label>{{title$ | async}}</mat-label>
      <input  matInput
        [type]="passwordHide ? 'password' : 'text'"
        [required]="isRequired"
        #inputElement
        [ngModel]="value$ | async"
        (ngModelChange)="onModelChange($event)"
        />
      <button mat-icon-button matSuffix (click)="passwordHide = !passwordHide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="passwordHide">
        <mat-icon>{{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
      <mat-error>
        Wert eingegeben!
      </mat-error>
    </mat-form-field>
  }
  @case("textarea") {
    <mat-form-field class="width100procent rahmen">
      <mat-label>{{title$ | async}}</mat-label>
      <textarea   matInput
        [readonly]="readonly"
        [required]="isRequired"
        [rows]="textAreaRows"
        #inputElement
        [ngModel]="value$ | async | objectToJson"
        (ngModelChange)="onModelChange($event)"
      ></textarea>
      <mat-error>
        Wert eingegeben!
      </mat-error>
    </mat-form-field>
  }
  @case("number") {
    <mat-form-field class="width100procent rahmen">
      <mat-label>{{title$ | async}}</mat-label>
      <input  matInput
        type="number"
        [readonly]="readonly"
        [required]="isRequired"
        [min]="min"
        [max]="max"
        [step]="step"
        #inputElement="ngModel"
        id=""
        [ngModel]="value$ | async"
        (ngModelChange)="onModelChange($event)"
        />
      @if (inputElement.value && withClearButton) {
        <button matSuffix mat-icon-button aria-label="Clear"
          (click)="clearValue()">
          <mat-icon>close</mat-icon>
        </button>
      }
      @if(inputElement.hasError('required')) {
        <mat-error>
          Wert eingegeben!
        </mat-error>
      }
      @if(inputElement.hasError('min')) {
        <mat-error>
          Der Wert darf nicht kleiner als {{min}} sein.
        </mat-error>
      }
      @if(inputElement.hasError('max')) {
        <mat-error>
          Der Wert darf nicht größer als {{max}} sein.
        </mat-error>
      }
    </mat-form-field>
  }
  @default {
    <mat-form-field class="width100procent rahmen">
      <mat-label>{{title$ | async}}</mat-label>
      <input  matInput
        [readonly]="readonly"
        [required]="isRequired"
        #inputElement="ngModel"
        id=""
        [ngModel]="value$ | async"
        (ngModelChange)="onModelChange($event)"
        />
      @if (inputElement.value && withClearButton) {
        <button matSuffix mat-icon-button aria-label="Clear"
          (click)="clearValue()">
          <mat-icon>close</mat-icon>
        </button>
      }
      @if(inputElement.hasError('required')) {
        <mat-error>
          Ein Wert muss eingegeben werden.
        </mat-error>
      }
    </mat-form-field> }
  }
